import {useMemo} from 'react'
import {useTable, ColumnInstance, Row} from 'react-table'
import {CustomHeaderColumn} from './columns/CustomHeaderColumn'
import {CustomRow} from './columns/CustomRow'
import {useQueryResponseData, useQueryResponseLoading} from '../core/QueryResponseProvider'
import {facilitesColumns} from './columns/_columns'
import {Facility} from '../core/_models'
import {DataLoading} from '../../../../../_dashboard/partials/components/loading/DataLoading'
import {KTCardBody} from '../../../../../_dashboard/helpers'
import { useQueryResponsePagination } from '../core/useQueryPagination'
import { useQueryRequest } from '../core/QueryRequestProvider'
import { Pagination } from '../../../../../_dashboard/helpers/crud-helper/pagination/PaginationComponent'
import { useIntl } from 'react-intl'

const FacilitesTable = () => {
  const intl = useIntl();
  const FacilitesData = useQueryResponseData()
  const isLoading = useQueryResponseLoading()
  const pagination = useQueryResponsePagination()
  const {updateState} = useQueryRequest()
  const data = useMemo(() => FacilitesData, [FacilitesData])
console.log("data"+JSON.stringify(FacilitesData))
  const columns = useMemo(() => facilitesColumns, [])
  const {getTableProps, getTableBodyProps, headers, rows, prepareRow} = useTable({
    columns,
    data: data || [], // Ensure data is always an array
  })


  return (
    <KTCardBody className='py-4'>
      <div className='table-responsive'>
        <table
          id='kt_table_users'
          className='table align-middle table-row-bordered  fs-6 gy-5 dataTable no-footer'
          {...getTableProps()}
        >
          <thead>
            <tr className='text-start text-muted fw-bolder fs-7 text-uppercase gs-0'>
              {headers.map((column: ColumnInstance<Facility>) => (
                <CustomHeaderColumn key={column.id} column={column} />
              ))}
            </tr>
          </thead>
          <tbody className='text-gray-600 fw-bold' {...getTableBodyProps()}>
            {rows.length > 0 ? (
              rows.map((row: Row<Facility>, i) => {
                prepareRow(row)
                return <CustomRow row={row} key={`row-${i}-${row.id}`} />
              })
            ) : (
              <tr>
                <td colSpan={7}>
                  <div className='d-flex text-center w-100 align-content-center justify-content-center'>
                  {intl.formatMessage({ id: 'COMMON.EMPTY_DATA' })}                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <Pagination pagination={pagination} isLoading={isLoading} updateState={updateState} />
      {isLoading && <DataLoading />}
    </KTCardBody>
  )
}

export {FacilitesTable}
